/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {PickAndClickController} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {AvalancheReelController} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelController";
import {AvalancheReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelPartAnimator";
import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {AvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/AvalancheZeroBetController";
import {FreespinAvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinAvalancheZeroBetController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {BackgroundIdleAnimation} from "./background/BackgroundIdleAnimation";
import {DTBackground} from "./background/DTBackground";
import {BetWaysOnReel} from "./betwaysonreel/BetWaysOnReel";
import {DragonTribeFontConfig} from "./DragonTribeFontConfig";
import {DragonTribeGameAssets} from "./DragonTribeGameAssets";
import {DragonTribeGameConfig} from "./DragonTribeGameConfig";
import {DragonTribeSoundConfig} from "./DragonTribeSoundConfig";
import {DragonTribeIntroView} from "./intro/DragonTribeIntroView";
import {DTReelController} from "./reel/DTReelController";
import {DTReelPartAnimator} from "./reel/DTReelPartAnimator";
import {ReelExpansionController} from "./reel/reelextention/ReelExpansionController";
import {DTReels} from "./reelarea/DTReels";
import {FreespinNoWinPause} from "./reelstoppresentation/FreespinNoWinPause";
import {ScatterAttention} from "./reelstoppresentation/ScatterAttention";
import {WildAttention} from "./reelstoppresentation/WildAttention";
import {WildSymbolNudge} from "./reelstoppresentation/wildsymbolnudge/WildSymbolNudge";
import {DTFreespinIntroController} from "./screen/freespinintro/DTFreespinIntroController";
import {DTFreespinIntroScreenView} from "./screen/freespinintro/DTFreespinIntroScreenView";
import {DTFreespinOutroController} from "./screen/freespinoutro/DTFreespinOutroController";
import {DTFreespinOutroView} from "./screen/freespinoutro/DTFreespinOutroView";
import {DragonTribeParsedGameData} from "./server/data/DragonTribeParsedGameData";
import {DragonTribeParsedInitData} from "./server/data/DragonTribeParsedInitData";
import {DragonTribeServerDataParser} from "./server/DragonTribeServerDataParser";
import {DTSoundPlayer} from "./soundplayer/DTSoundPlayer";
import {DTSpinController} from "./spin/DTSpinController";
import {DTReelSymbol} from "./symbols/DTReelSymbol";
import {DTReelSymbolH} from "./symbols/DTReelSymbolH";
import {DTReelSymbolL} from "./symbols/DTReelSymbolL";
import {DTReelSymbolM} from "./symbols/DTReelSymbolM";
import {DTReelSymbolMystery} from "./symbols/DTReelSymbolMystery";
import {DTReelSymbolName} from "./symbols/DTReelSymbolName";
import {DTReelSymbolStateCreator} from "./symbols/DTReelSymbolStateCreator";
import {SymbolWinAnimation} from "./symbols/SymbolWinAimation";
import {ScatterWin} from "./winpresentation/addfsscreendelay/ScatterWin";
import {DragonTribeBigWinController} from "./winpresentation/bigwin/DragonTribeBigWinController";
import {FSWildMeter} from "./winpresentation/fswildmeter/FSWildMeter";
import {DragonTribeInitialWPController} from "./winpresentation/initial/DragonTribeInitialWPController";
import {Plus2Spins} from "./winpresentation/plus2spins/Plus2Spins";
import {FeaturePrice} from "./server/FeaturePrice";

export class DragonTribeGameModuleConfig implements IGameModuleConfig {

    public static instance:DragonTribeGameModuleConfig = new DragonTribeGameModuleConfig();
    public static background:DTBackground;
    public static betWaysOnReel:BetWaysOnReel;
    public static symbolWinAnimation:SymbolWinAnimation;
    public static soundPlayer:DTSoundPlayer;
    public static featurePrice:FeaturePrice;

    GAME_CONFIG:IGameConfig = DragonTribeGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = DragonTribeSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = DragonTribeFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = DragonTribeGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => {
        return new DragonTribeServerDataParser();
    };
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {
        return new DragonTribeParsedInitData(data, <DragonTribeServerDataParser>dataParser);
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {
        return new DragonTribeParsedGameData(data, <DragonTribeServerDataParser>dataParser);
    };

    SPIN_CONTROLLER?:() => SpinController = () => {
        return new DTSpinController();
    };

    REELS:() => Reels = () => {
        return new DTReels();
    };

    REEL_CONTROLLER:(reelId:number) => AvalancheReelController = reelId => {
        return new DTReelController(reelId);
    };

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    REEL_PART_ANIMATOR:(reelId:number) => AvalancheReelPartAnimator = (reelId) => {
        return new DTReelPartAnimator(reelId);
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig):DTReelSymbol => {
                if(symName.indexOf("W") > -1 || symName.indexOf("S") > -1) {
                    return new DTReelSymbolH(symName, reelId, state, size);
                }
                if(symName === DTReelSymbolName.MYSTERY) {
                    return new DTReelSymbolMystery(symName, reelId, state, size);
                }
                if(symName.indexOf("M") > -1) {
                    return new DTReelSymbolM(symName, reelId, state, size);
                }
                if(symName.indexOf("L") > -1) {
                    return new DTReelSymbolL(symName, reelId, state, size);
                }
                return new DTReelSymbol(symName, reelId, state, size);
            });
    };

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => {
        return new DTReelSymbolStateCreator();
    };

    INTRO_VIEW:(onClickCallback:() => void) => DragonTribeIntroView =
        (onClickCallback:() => void) => new DragonTribeIntroView({
            layer : DragonTribeGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : DragonTribeGameAssets.INTRO_BACKGROUND},
            },
            featureIcons : {
                icons : [IntroFeatureLogo.X_NUDGE, IntroFeatureLogo.X_WAYS, IntroFeatureLogo.VOLATILITY_EXTREME]
            },
            mobileScale : 1.2,
            portraitScale : 1.7
        });

    PICK_AND_CLICKS:(() => PickAndClickController)[] = [
        () => new DTFreespinIntroController({
            viewCreator : (onButtonClickCallback:(index:number, auto:boolean) => void, autoClick?:boolean) => {
                return new DTFreespinIntroScreenView({
                    layer : DragonTribeGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    recreateButtons : false
                });
            },
            showWinPresentations : false,
            autoClickTime : 20
        })
    ];


    SCREENS:(() => ScreenController)[] = [
        () => {
            return new DTFreespinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new DTFreespinOutroView({
                        layer : DragonTribeGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        },
                        mobileScale : 1.2,
                        portraitScale : 1.5
                    }, autoClose);
                }
            });
        }
    ];
    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new AvalancheZeroBetController(),
        () => new FreespinZeroBetController(),
        () => new FreespinAvalancheZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new FreespinNoWinPause(index),
        index => new WildAttention(index),
        index => new ScatterAttention(index),
        index => new ReelExpansionController(index),
        index => new WildSymbolNudge(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new DragonTribeInitialWPController(indexes)],
        [indexes => new DragonTribeBigWinController(indexes)],
        [indexes => new FSWildMeter(indexes)],
        [indexes => new Plus2Spins(indexes)],
        [indexes => new ScatterWin(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new BetWayWinIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        const idleAnimation:BackgroundIdleAnimation = new BackgroundIdleAnimation({
            startTime : 3,
            minInterval : 15,
            maxInterval : 30
        });
        DragonTribeGameModuleConfig.background = new DTBackground({
            layer : DragonTribeGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : DragonTribeGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN_PICK : {
                    image : DragonTribeGameAssets.MAIN_GAME_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                },
                FREESPIN : {image : DragonTribeGameAssets.FS_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                NORMAL_AVALANCHE : {
                    image : DragonTribeGameAssets.MAIN_GAME_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                },
                FREESPIN_AVALANCHE : {
                    image : DragonTribeGameAssets.FS_GAME_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                }
            },
            stretch : false
        });

        DragonTribeGameModuleConfig.soundPlayer = new DTSoundPlayer();
        DragonTribeGameModuleConfig.symbolWinAnimation = new SymbolWinAnimation();
        DragonTribeGameModuleConfig.betWaysOnReel = new BetWaysOnReel();

        StageManager.legacyScaling = true;
        DragonTribeGameModuleConfig.featurePrice = new FeaturePrice();
    };

    constructor() {
        if(DragonTribeGameModuleConfig.instance) {
            throw new Error("DragonTribeGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}